const prefix = "property-categories";

export const fetch_property_categories_url = `${process.env.REACT_APP_API_URL}/${prefix}`;
export const create_property_categories_url = `${process.env.REACT_APP_API_URL}/${prefix}`;
export const update_property_categories_url = `${process.env.REACT_APP_API_URL}/${prefix}`;
export const query_property_categories_url = `${process.env.REACT_APP_API_URL}/${prefix}/query`;
export const delete_property_categories_url = `${process.env.REACT_APP_API_URL}/${prefix}`;
